import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Badge, Card, CardContent } from '@cartcloser/ui';
import { formatMicros, listConversations } from '../lib/api.js';

export const Route = createFileRoute('/admin/$slug/conversations/')({
  component: ConversationsList,
});

function ConversationsList() {
  const { slug } = Route.useParams();
  const query = useQuery({
    queryKey: ['conversations', slug],
    queryFn: () => listConversations(slug),
  });

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Conversations</h1>
          <p className="text-sm text-muted-foreground">
            Every chat, with the products each turn considered and the call cost.
          </p>
        </div>
        <a
          href={`/api/admin/${encodeURIComponent(slug)}/conversations/export.csv`}
          className="rounded-md border border-border px-3 py-1.5 text-sm font-medium hover:bg-accent"
        >
          Export CSV
        </a>
      </div>

      <div className="grid gap-2">
        {query.isLoading ? (
          <p className="text-sm text-muted-foreground">Loading…</p>
        ) : query.data && query.data.length > 0 ? (
          query.data.map((c) => (
            <Link
              key={c.id}
              to="/admin/$slug/conversations/$id"
              params={{ slug, id: c.id }}
              className="block"
            >
              <Card className="transition-colors hover:border-primary/40">
                <CardContent className="flex items-center justify-between p-4 text-sm">
                  <div className="min-w-0">
                    <p className="font-medium">{c.expertiseRouted ?? 'Unrouted'}</p>
                    <p className="text-xs text-muted-foreground">
                      {new Date(c.startedAt).toLocaleString()}
                    </p>
                    {c.models.length > 0 ? (
                      <p className="truncate text-xs text-muted-foreground">{c.models.join(', ')}</p>
                    ) : null}
                  </div>
                  <div className="flex shrink-0 items-center gap-3">
                    {c.reachedRecommendation ? (
                      <Badge variant="success">Recommended</Badge>
                    ) : (
                      <Badge variant="secondary">No rec</Badge>
                    )}
                    {/* Local Ollama runs are effectively free — the $ figure is
                        notional, so strike it through. */}
                    {c.local ? (
                      <span className="text-muted-foreground">
                        <s>{formatMicros(c.costMicros)}</s>{' '}
                        <span className="text-xs">local</span>
                      </span>
                    ) : (
                      <span className="text-muted-foreground">{formatMicros(c.costMicros)}</span>
                    )}
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))
        ) : (
          <p className="text-sm text-muted-foreground">
            No conversations yet. Try the Sandbox to create one.
          </p>
        )}
      </div>
    </div>
  );
}
